import React from 'react';

import { OpsgenieIcon } from '@atlaskit/temp-nav-app-icons/opsgenie';

import { Products } from '../../constants';
import { GlobalShortcutsItem } from '../../types';

export default function opsgenie(fallbackUrl: () => string): GlobalShortcutsItem {
	return {
		icon: <OpsgenieIcon size="20" />,
		label: 'Opsgenie',
		apsKey: Products.OPSGENIE,
		fallbackUrl,
	};
}
